// React
import React, { useEffect, useState } from "react";

// MUI
import {
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Paper,
  Tooltip,
} from "@mui/material";

//MUI ICON
import InfoIcon from "@mui/icons-material/Info";

// Formik
import { useFormik } from "formik";

//Components
import Dropzone from "components/Dropzone_one";

import { QRCodeCanvas } from "qrcode.react";

// import CustomDropzone from "components/Dropzone";
import { GradientShadow } from "components/GradientButton";

// Other
import { Divider } from "antd";
import Swal from "sweetalert2";

// กำนหดตัวแปรสำหรับการดึงข่้อมูลไปแสดงผลใน Field ของผู้ที่มาซื้อ
const customerFields = [
  {
    label: "คำนำหน้า",
    name: "prefix",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    label: "ชื่อ-นามสกุล",
    name: "fullName",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    label: "เลขบัตรประชาชน",
    name: "idCardNumber",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    label: "เบอร์โทรศัพท์",
    name: "phoneNumber",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    label: "ที่อยู่",
    name: "address",
    type: "text",
    required: true,
    disabled: true,
  },
  { label: "สัญชาติ", name: "nationality", type: "text", disabled: true },
];

// กำนหดตัวแปรสำหรับการดึงข่้อมูลไปแสดงผลใน Field หมวดหมู่
const categoryOptions = [
  { label: "เครื่องประดับ", id: 1 },
  { label: "อิเล็กทรอนิกส์", id: 2 },
  { label: "ทองคำ", id: 3 },
  { label: "พระเครื่อง", id: 4 },
  { label: "แบรนด์เนม", id: 5 },
  { label: "นาฬิกา", id: 6 },
];

const ViewModalReadyItems = ({
  open,
  onClose,
  selectedProduct,
  fetchProductData,
}) => {
  // ตัวแปรสำหรับเก็บข้อมูลรูปภาพ
  const [files1, setFiles1] = useState([]);
  const [files2, setFiles2] = useState([]);
  const [error1, setError1] = useState(null);
  const [error2, setError2] = useState(null);
  const [initialProductUrls, setInitialProductUrls] = useState([]);
  const [customerImages, setCustomerImages] = useState([]);
  const [deletedImageIds, setDeletedImageIds] = useState([]);

  // ตัวแปรสำหรับเก็บข้อของ Box แสดง Product
  const [productBoxes, setProductBoxes] = useState([
    { id: 1, isExpanded: true },
  ]);
  const [statusSave, setStatusSave] = useState(false); // เก็บ status หลังจากมีการเพิ่ม Box
  const [currentStep, setCurrentStep] = useState(1); // Track the current step
  const [activeButton, setActiveButton] = useState("pawnContract");

  //เก็บตัวแปร id หลังจากสร้าง product เสร็จ
  const [newIds, setNewIds] = useState([]);

  //   if (selectedProduct) {
  //     // console.log('check image',selectedProduct)
  //     if (selectedProduct.picture && Array.isArray(selectedProduct.picture)) {
  //       const productImageUrls = selectedProduct.picture.map(
  //         (img) => img.picture
  //       );
  //       setInitialProductUrls(productImageUrls);
  //     }
  //     // if (selectedProduct.customer_image) {
  //     //   setInitialCustomerUrls([selectedProduct.customer_image]);
  //     // }
  //   }
  // }, [selectedProduct]);

  // console.log("checking picture display in modal", initialProductUrls);
  useEffect(() => {
    if (selectedProduct) {
      // console.log("selectedProduct", selectedProduct);
      formik.setValues({
        product_code: selectedProduct.product_code || "",
        product_name: selectedProduct.product_name || "",
        product_code_com: selectedProduct.product_code_com || "",
        category_id: selectedProduct.category_id
          ? categoryOptions.find(
              (category) => category.id === selectedProduct.category_id
            )?.id || ""
          : "",
        detail: selectedProduct.detail || "",
        blemishes: selectedProduct.blemishes || "",
        notes: selectedProduct.notes || "",
        size: selectedProduct.size || "",
        remaining_amount: selectedProduct.remaining_amount || 1,
        price: selectedProduct.price || 0,
        total_price:
          selectedProduct.remaining_amount * selectedProduct.price || 0,
        product_images: selectedProduct.picture || "",
        // customer fields
        prefix: selectedProduct.prefix || "",
        fullName: selectedProduct.customer_name || "",
        idCardNumber: selectedProduct.idcard || "",
        phoneNumber: selectedProduct.customer_phonenumber || "",
        address: selectedProduct.customer_address || "",
        nationality: selectedProduct.nationality || "",
      });

      // Set initial image URLs
      // ตรวจสอบว่า selectedProduct.picture มีค่าหรือไม่
      // console.log("selectedProduct.picture", selectedProduct?.picture);

      if (selectedProduct?.picture && Array.isArray(selectedProduct.picture)) {
        const productImageUrls = selectedProduct.picture.map(
          (img) => img.picture[0]
        );
        console.log("productImageUrls", productImageUrls);
        setInitialProductUrls(productImageUrls);
      } else {
        // console.log("selectedProduct.picture is empty or not an array.");
      }

      // Set initial image URLs
      if (selectedProduct.customer_images) {
        setCustomerImages(selectedProduct.customer_images);
      }
    }
  }, [selectedProduct, categoryOptions]);

  //ฟังก์ชันเปลี่ยนหน้า
  const handleNextStep = () => {
    setCurrentStep(currentStep + 1); // Go to the next "page"
  };

  //ฟังก์ชันสำหรับการเปลี่ยนหน้าแสดงผลใน Modal
  const handleBackToStep1 = () => {
    setCurrentStep(1); // Reset back to the first step if needed
  };

  // ฟังก์ชันเพิ่ม product box
  const addProductBox = () => {
    if (productBoxes.length < 15) {
      setProductBoxes([
        ...productBoxes,
        { id: productBoxes.length + 1, isExpanded: false },
      ]);
      setStatusSave(false);
    } else {
      alert("คุณสามารถเพิ่มสินค้าได้สูงสุด 15 รายการเท่านั้น");
    }
  };

  // Function to convert object to FormData
  const tranFormObjectToFormData = (obj) => {
    const formData = new FormData();
    Object.entries(obj).forEach(([key, value]) => {
      if (
        (key === "category_id" ||
          key === "payment_channel" ||
          key === "market_channel") &&
        value &&
        value.id
      ) {
        formData.append(key, value.id);
      } else if (Array.isArray(value)) {
        value.forEach((file, index) => {
          formData.append(`${key}[${index}]`, file);
        });
      } else {
        formData.append(key, value);
      }
    });
    return formData;
  };

  const objectToFormData = (obj, formData = new FormData(), parentKey = "") => {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        // ตรวจสอบว่า key นั้นเป็น property ของ obj เอง
        const value = obj[key];
        const formKey = parentKey ? `${parentKey}[${key}]` : key; // จัดการสร้างคีย์สำหรับกรณีของออบเจ็กต์ซ้อน

        if (value instanceof File) {
          // ตรวจสอบว่าค่านั้นเป็นไฟล์หรือไม่
          formData.append(formKey, value); // เพิ่มไฟล์ลงใน formData
        } else if (typeof value === "object" && value !== null) {
          // ถ้าค่าเป็นออบเจ็กต์
          objectToFormData(value, formData, formKey); // เรียกใช้งานฟังก์ชันแบบ recursive
        } else {
          formData.append(formKey, value); // เพิ่มค่านั้นลงใน formData
        }
      }
    }
    return formData; // คืนค่า formData ที่สร้างเสร็จแล้ว
  };

  // const handleCheckboxChange = (event) => {
  //   setIsChecked(event.target.checked);
  // };

  // Formik hook
  const formik = useFormik({
    initialValues: {
      //สำหรับกำหนดค่า สินค้า
      product_code: "",
      product_code_com: "",
      product_name: "",
      category_id: null,
      detail: "",
      blemishes: "",
      size: "",
      remaining_amount: 1,
      price: 0,
      total_price: 0,
      notes: "",
      //สำหรับกำหนดค่า รายละเอียดลูกค้า
      fullName: "",
      idCardNumber: "",
      phoneNumber: "",
      address: "",
      //สำหรับกำหนดค่า รายละเอียดการขาย
      payment_channel: "",
      market_channel: "",
      amount: 0,
      price_detail: "",
      discount_price: 0,
      total_discount_price: 0,
      discount_rate: 0,
      sum_discount_price: 0,
      // total_price: 0,
      order_total_price: "",
      //ใบประกัน
      is_warranty_enabled: false,
      resale_product_percentage: 0,
      change_product_percentage: 0,
    },
  });

  // ฟังก์ชันการแสดงฟิลด์ Customer
  const renderFieldsCustomer = (fields) => {
    return fields.map((field, index) => (
      <React.Fragment key={index}>
        <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
          <Box display="flex" alignItems="center">
            <Typography
              variant="subtitle1"
              sx={{ width: "200px", whiteSpace: "nowrap" }}
            >
              {field.label}
              {field.required && (
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              )}
            </Typography>
            <TextField
              disabled={field.disabled}
              id={field.name}
              name={field.name}
              type={field.type}
              value={formik.values[field.name]}
              onChange={formik.handleChange}
              {...getFieldProps(field.name)}
              error={
                formik.touched[field.name] && Boolean(formik.errors[field.name])
              }
              helperText={
                formik.touched[field.name] && formik.errors[field.name]
              }
              fullWidth
              InputProps={{
                sx: { height: "40px", padding: "0px" }, // Ensure consistent height and padding
                inputProps: {
                  style: {
                    "-moz-appearance": "textfield",
                    "-webkit-appearance": "none",
                    appearance: "none",
                  },
                  maxLength:
                    field.name === "idCardNumber"
                      ? 13
                      : field.name === "phoneNumber"
                      ? 10
                      : undefined,
                  inputMode: field.type === "text" ? "numeric" : undefined,
                  pattern: field.type === "text" ? "[0-9]*" : undefined,
                },
              }}
            />
          </Box>
        </Grid>
      </React.Fragment>
    ));
  };

  // ฟังก์ชันการแสดงฟิลด์ของ Product
  const renderProductBoxes = () => {
    return productBoxes.map((box) => (
      <Box
        key={box.id}
        sx={{
          my: 2,
          border: "1px solid #ddd",
          p: 2,
          borderRadius: "12px",
          backgroundColor: "#ffffff",
        }}
      >
        <Grid container spacing={2} style={{ marginTop: "10px" }}>
          {/* Product QRCode Row */}
          <Grid item xs={12}>
            <Grid container alignItems="top">
              <Grid item xs={2}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography>QR Code {""}</Typography>
                </div>
              </Grid>

              <Grid item xs={10}>
                <QRCodeCanvas
                  value={formik.values.product_code || ""} // ดึงค่าจาก formik และใช้ค่าที่ว่างเป็นค่า default ถ้าไม่พบ
                  size={64} // ขนาดของ QR Code
                  bgColor={"#ffffff"} // สีพื้นหลัง
                  fgColor={"#000000"} // สีของ QR Code
                  level={"H"} // ระดับการกู้คืนข้อมูล (L, M, Q, H)
                />
              </Grid>
            </Grid>
          </Grid>
          {/* Product Code Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography>รหัสสินค้า {""}</Typography>
                </div>
              </Grid>

              <Grid item xs={10}>
                <Typography>{formik.values.product_code || ""}</Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* Product Code2 Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography>รหัส 2 {""}</Typography>
                  <Tooltip title="รหัสสินค้าภายในร้านที่สามารถกำหนดเองได้">
                    <InfoIcon style={{ color: "#e5e5e5", marginRight: 10 }} />
                  </Tooltip>
                </div>
              </Grid>

              <Grid item xs={10}>
                <Typography>{formik.values.product_code_com || ""}</Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Product Name Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  ชื่อสินค้า{""}
                  {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography>{formik.values.product_name || ""}</Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Product Category Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  หมวดหมู่{""}
                  {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography>
                  {
                    (
                      categoryOptions.find(
                        (option) => option.id === formik.values.category_id
                      ) || { label: "" }
                    ).label
                  }
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Product Detail Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>รายละเอียด</Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography>{formik.values.detail || ""}</Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Product Blemishes Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>ตำหนิ</Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography>{formik.values.blemishes || ""}</Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Product Size Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>ขนาด</Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography>{formik.values.size || ""}</Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Product Total amount Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  จำนวน{" "}
                  {/* <span style={{ color: "red", marginLeft: "3px" }}>*</span> */}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography>{formik.values.remaining_amount || ""}</Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Product Price Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  ราคาทุน{""}
                  {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography>{formik.values.price || ""}</Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Product Total Price Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  ราคารวม{""}
                  {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography>{formik.values.total_price || ""}</Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Product Notes Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>หมายเหตุ</Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography>{formik.values.notes || ""}</Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Product Image Row */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mb: 2 }}>
              รูปทรัพย์
            </Typography>
            <Grid item xs={12}>
              {initialProductUrls.map((url, index) => (
                <img
                  src={url}
                  alt={`Preview ${index}`}
                  style={{
                    width: "200px",
                    height: "200px",
                    objectFit: "cover",
                  }}
                />
              ))}
            </Grid>

            {error1 && (
              <Typography variant="caption" color="error">
                {error1}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Box>
    ));
  };

  // ฟังก์ชันการแสดง ช่องทางการชำระ

  //กรณีปิดหน้าต่าง Modal
  const handleCancel = () => {
    const formHasUnsavedChanges = Object.keys(touched).some(
      (field) => touched[field]
    );

    // console.log('formHasUnsavedChanges', formHasUnsavedChanges);
    // Prompt the user to confirm before closing if there are unsaved changes
    if (formHasUnsavedChanges) {
      Swal.fire({
        title: "Cancel",
        text: "If you cancel now, your information fills will be discarded.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0066FF",
        cancelButtonColor: "#0066FF",
        reverseButtons: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Keep Editing",
        customClass: {
          confirmButton: "confirm-rounded-button",
          cancelButton: "outlined-button",
          container: "swal2-container-custom", // Add custom class for container
        },
        didOpen: () => {
          // Set z-index in didOpen to ensure it's applied after dialog is rendered
          document.querySelector(".swal2-container-custom").style.zIndex = 1500; // or a higher value
        },
        iconHtml:
          '<svg width="150" height="150" viewBox="0 0 47 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.4339 0.666016C36.3209 0.666016 46.7673 11.1123 46.7673 23.9993C46.7673 36.8863 36.3209 47.3327 23.4339 47.3327C10.5469 47.3327 0.100586 36.8863 0.100586 23.9993C0.100586 11.1123 10.5469 0.666016 23.4339 0.666016ZM23.4339 5.33268C18.4832 5.33268 13.7353 7.29934 10.2346 10.8C6.73391 14.3007 4.76725 19.0486 4.76725 23.9993C4.76725 28.9501 6.73391 33.698 10.2346 37.1987C13.7353 40.6994 18.4832 42.666 23.4339 42.666C28.3846 42.666 33.1326 40.6994 36.6332 37.1987C40.1339 33.698 42.1006 28.9501 42.1006 23.9993C42.1006 19.0486 40.1339 14.3007 36.6332 10.8C33.1326 7.29934 28.3846 5.33268 23.4339 5.33268ZM23.4339 30.9993C24.0528 30.9993 24.6462 31.2452 25.0838 31.6828C25.5214 32.1203 25.7673 32.7138 25.7673 33.3327C25.7673 33.9515 25.5214 34.545 25.0838 34.9826C24.6462 35.4202 24.0528 35.666 23.4339 35.666C22.8151 35.666 22.2216 35.4202 21.784 34.9826C21.3464 34.545 21.1006 33.9515 21.1006 33.3327C21.1006 32.7138 21.3464 32.1203 21.784 31.6828C22.2216 31.2452 22.8151 30.9993 23.4339 30.9993ZM23.4339 9.99935C24.0528 9.99935 24.6462 10.2452 25.0838 10.6828C25.5214 11.1204 25.7673 11.7138 25.7673 12.3327V26.3327C25.7673 26.9515 25.5214 27.545 25.0838 27.9826C24.6462 28.4202 24.0528 28.666 23.4339 28.666C22.8151 28.666 22.2216 28.4202 21.784 27.9826C21.3464 27.545 21.1006 26.9515 21.1006 26.3327V12.3327C21.1006 11.7138 21.3464 11.1204 21.784 10.6828C22.2216 10.2452 22.8151 9.99935 23.4339 9.99935Z" fill="#ED4040"/></svg>',
      }).then(async (result) => {
        if (result.isConfirmed) {
          formik.resetForm();
          setFiles1([]); // Clear product images
          setFiles2([]); // Clear customer images
          setInitialProductUrls([]); // Clear initial product image URLs
          // setInitialCustomerUrls([]);
          setDeletedImageIds([]);
          onClose();
          setNewIds([]);
        }
      });
    } else {
      formik.resetForm();
      setFiles1([]); // Clear product images
      setFiles2([]); // Clear customer images
      setInitialProductUrls([]); // Clear initial product image URLs
      // setInitialCustomerUrls([]);
      setDeletedImageIds([]);
      onClose();
      setNewIds([]);
    }
  };

  const { errors, touched, getFieldProps, handleSubmit } = formik;

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        //ป้องกันการกดเบื้องหลังแล้วหลุด
        if (reason !== "backdropClick") onClose();
      }}
      disableEscapeKeyDown
      fullWidth
      maxWidth="lg"
      sx={{
        borderRadius: "8px",
      }}
    >
      <>
        {/* หน้าที่ 1 : Form */}
        <DialogTitle style={{ backgroundColor: "#F1F2F7" }}>
          <Typography variant="h4">ดูรายละเอียดสินค้า</Typography>
        </DialogTitle>
        <DialogContent style={{ backgroundColor: "#F1F2F7" }}>
          <form onSubmit={formik.handleSubmit}>
            {/* Render the product boxes */}
            <Grid item xs={12} sx={{ mx: 2 }}>
              <Typography sx={{ mb: 1, ml: 2 }} variant="h5">
                ข้อมูลลูกค้า
              </Typography>
              <Paper sx={{ p: 2, borderRadius: "12px" }}>
                <Grid container>
                  <Grid item xs={7}>
                    {renderFieldsCustomer(customerFields)}
                  </Grid>
                  <Grid item xs={5} sx={{ mt: 2 }}>
                    {selectedProduct ? (
                      <img
                        src={selectedProduct.customer_image}
                        alt="Preview"
                        style={{
                          width: "200px",
                          height: "200px",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <Dropzone
                        files={files2}
                        setFiles={setFiles2}
                        setError={setError2}
                      />
                    )}
                    {error2 && (
                      <Typography variant="caption" color="error">
                        {error2}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Paper>

              <Grid items xs={12}>
                {/* Render the product boxes */}
                <Typography sx={{ mb: 2, mt: 3, ml: 2 }} variant="h5">
                  ข้อมูลสินค้า
                </Typography>
                {renderProductBoxes()}
              </Grid>
            </Grid>
          </form>
        </DialogContent>

        <DialogActions
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0 16px 16px 16px",
            backgroundColor: "#F1F2F7",
          }}
        >
          {/* Dialog Actions */}
          <Grid container sx={{ mx: 3 }}>
            <Grid item xs={12}>
              <Divider
                style={{
                  marginTop: "0",
                  marginBottom: "16px",
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              container
              justifyContent="space-between" // Apply flex properties to align buttons
            >
              <GradientShadow
                onClick={handleCancel}
                sx={{
                  borderRadius: "12px", // Make the button circular
                  minWidth: "150px", // Adjust the width
                  minHeight: "20px", // Adjust the height
                  padding: 0, // Remove padding to center the icon better
                  borderColor: "#c4c4c4", // Light grey border
                  color: "#6c6c6c", // Light grey icon color
                  display: "flex", // Ensure flexbox is used
                  alignItems: "center", // Center vertically
                  justifyContent: "center", // Center horizontally
                  "&:hover": {
                    borderColor: "#a0a0a0", // Darker grey on hover
                  },
                }}
              >
                กลับ
              </GradientShadow>
            </Grid>
          </Grid>
        </DialogActions>
      </>
    </Dialog>
  );
};

export default ViewModalReadyItems;
